import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router'; // ✅ Import RouterModule
import { FormsModule } from '@angular/forms'; // Keep if you're using ngModel
import {
  DsBoxModule,
  DsBreadcrumbModule, DsButtonModule,
  DsCheckboxModule,
  DsColumnData,
  DsFormFieldModule, DsIconModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService, DsModalModule, DsPopoverModule,
  DsProgressCircleModule, DsRowData,
  DsSelectModule,
  DsTableModule,
  DsTabsModule,
  DsToastService,
} from '@bmw-ds/components';
import { FiltersComponent } from 'src/app/components/filters/filters.component';
import { ResultsCountComponent } from 'src/app/components/results-count/results-count.component';
import { CommonModule } from '@angular/common';
import { TableComponent } from '../../../components/table/table.component';
import {
  Unit,
  UnitSearchResponse,
  UnitSearchStockRequest,
} from '../../../models/unit-search-stock.model';
import { CrossBorderService } from '../../../services/crossborder.service';
import { CosyUrlResponse } from '../../../models/cosy.model';
import { PlannedVehicleRowData } from '../../../models/planned-vehicle-row.model';
import { NatisUserRequest } from '../../../models/user-details.model';
import {
  SmsRequest,
  SmsResponse,
  StockItem,
  StockOption,
} from '../../../models/sms.model';
import { SmsService } from '../../../services/sms.service';
import { catchError, forkJoin, of, takeUntil } from 'rxjs';
import { PricePerBodyRequest } from '../../../models/price-per-body.model';
import { PricePerBodyService } from '../../../services/price-per-body.service';
import { ModelPricingModalComponent } from '../../../components/modals/model-pricing/model-pricing-modal';
import { HttpErrorResponse } from '@angular/common/http';
import { UnitOverviewLinkPipe } from '../../../unit-overview.pipe';

@Component({
  selector: 'app-stock-unit-search',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    DsTabsModule,
    FormsModule,
    DsBreadcrumbModule,
    DsTableModule,
    DsSelectModule,
    DsFormFieldModule,
    DsCheckboxModule,
    DsProgressCircleModule,
    FiltersComponent,
    ResultsCountComponent,
    TableComponent,
    DsBoxModule,
    DsPopoverModule,
    ModelPricingModalComponent,
    DsIconModule,
    DsModalModule,
    DsButtonModule,
    UnitOverviewLinkPipe,
  ],
  templateUrl: './stock-unit-search.component.html',
  styleUrl: './stock-unit-search.component.scss',
})
export class StockUnitSearchComponent implements OnInit {
  requestPayload!: UnitSearchStockRequest;
  loadingAreaConfig: DsLoadingAreaConfiguration = {
    id: 'bodyLoading',
    loadingTitle: 'Loading...',
  };
  @ViewChild(ModelPricingModalComponent)
  modelPricingModal!: ModelPricingModalComponent;
  rowsData: PlannedVehicleRowData[] = [];
  filters = {
    impmodel: '',
    impmodel_group: '',
    impmodel_exopt1: '',
    impmodel_inopt1: '',
    impmodel_inopt2: '',
    impmodel_inopt3: '',
    impmodel_insel1: '',
  };
  callOption: string = '';
  plannedDealerColumnData: DsColumnData[] = [
    // { field: 'image', headerName: 'Image' },
    { field: 'VIN', headerName: 'Vin Number' },
    { field: 'modelCode', headerName: 'Model' },
    { field: 'status', headerName: 'Status' },
    { field: 'template', headerName: 'Template' },
    { field: 'b', headerName: 'B' },
    { field: 'productionWeek', headerName: 'PW' },
    { field: 'exterior', headerName: 'Exterior' },
    { field: 'interior', headerName: 'Interior' },
    { field: 'options', headerName: 'Options' },
    { field: 'freeAllocation', headerName: 'Free Allocation' },
    // { field: 'consignment', headerName: 'Con' },
    { field: 'comments', headerName: 'Comments' },
    // { field: 'otp', headerName: 'OTP' },
    { field: 'client', headerName: 'Client' },
    { field: 'action', headerName: '' },
  ];

  dealerColumnData: DsColumnData[] = [
    // { field: 'image', headerName: 'Image' },
    { field: 'VIN', headerName: 'Vin Number' },
    { field: 'modelCode', headerName: 'Model' },
    { field: 'status', headerName: 'Status' },
    { field: 'template', headerName: 'Template' },
    { field: 'b', headerName: 'B' },
    { field: 'productionWeek', headerName: 'PW' },
    { field: 'exterior', headerName: 'Exterior' },
    { field: 'interior', headerName: 'Interior' },
    { field: 'options', headerName: 'Options' },
    // { field: 'consignment', headerName: 'Con' },
    { field: 'comments', headerName: 'Comments' },
    // { field: 'otp', headerName: 'OTP' },
    { field: 'client', headerName: 'Client' },
    { field: 'action', headerName: '' },
  ];

  smsColumnData: DsColumnData[] = [
    // { field: 'image', headerName: 'Image' },
    { field: 'VIN', headerName: 'VIN' },
    { field: 'model', headerName: 'Model Code' },
    { field: 'stat', headerName: 'status' },
    { field: 'template', headerName: 'Template' },
    { field: 'pw', headerName: 'Prod Week' },
    { field: 'rfi', headerName: 'RFI' },
    { field: 'ltp', headerName: 'LTP' },
    { field: 'exterior', headerName: 'Exterior' },
    { field: 'interior', headerName: 'Interior' },
    { field: 'options', headerName: 'Options' },
    { field: 'action', headerName: '' },
  ];

  showTable: boolean = false;
  showResults: boolean = false;
  natisUserRequest: NatisUserRequest = {
    dealerCode: localStorage.getItem('dealerCode') || '',
    cNumber: localStorage.getItem('userId') || '',
  };

  ngOnInit(): void {
    // Initial actions if needed
    this.crossBorderService.getEncodedUserId(this.natisUserRequest).subscribe(
      (response) => {
        localStorage.setItem('euserid', response.ex_encrypted_password);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  onFiltersChanged(payload: UnitSearchStockRequest): void {
    console.log('payload', payload);
    this.requestPayload = payload;
  }

  constructor(
    private readonly loadingAreaService: DsLoadingAreaService,
    private readonly crossBorderService: CrossBorderService,
    private readonly cdr: ChangeDetectorRef,
    private readonly toastService: DsToastService,
    private readonly smsService: SmsService,
    private pricePerBodyService: PricePerBodyService
  ) {}

  // After fetching units from the API, update rowsData and showTable
  onPlannedDealerTabClick() {
    this.callOption = 'PLAND';
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Planned Vehicles',
    };
    if (!this.requestPayload) {
      this.requestPayload = {} as UnitSearchStockRequest;
      this.requestPayload.impdlr = localStorage.getItem('dealerCode') || '';
    }
    this.requestPayload.searchon = this.callOption;
    this.rowsData = [];
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.crossBorderService.getUnitSearchStock(this.requestPayload).subscribe(
      (response: UnitSearchResponse) => {
        this.showResults = true;
        if (response.unittab && response.unittab.length > 0) {
          this.rowsData = this.mapUnitsToRowsData(response.unittab);
          this.showTable = true;
          // this.rowsData.forEach((row, idx) => {
          //   const cosyRequest = { VIN: row['VIN'] };
          //   this.crossBorderService
          //     .getCosyUrl(cosyRequest)
          //     .subscribe((response: CosyUrlResponse) => {
          //       this.rowsData[idx]['image'] =
          //         response.exturl || 'image placeholder';
          //     });
          // });
        } else {
          this.showTable = false;
          this.rowsData = [];
        }
        this.cdr.detectChanges();
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      (error) => {
        console.error('Error fetching units:', error);
        this.showTable = false;
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      }
    );
  }

  mapUnitsToRowsData(units: Unit[]): PlannedVehicleRowData[] {
    return units.map((unit) => ({
      image: unit.exturl || 'image placeholder',
      VIN: unit.zvin || unit.zorder,
      bodyNo: unit.zbody,
      modelCode: `${unit.zmodel} - ${unit.zmoddesc}`,
      status: unit.stat_code,
      template: unit.template_id,
      b: unit.order_temp_broken,
      RFI: unit.rfi_date,
      lastTrackPoint: unit.invc_block_ind,
      transmission: unit.ztrans,
      productionWeek: unit.zprodw,
      exterior: unit.extcolr,
      interior: unit.inttrim,
      options: Array.isArray(unit.opttble)
        ? [
            ...unit.opttble.map((opt) => ({
              optionIndicator: 'S',
              selection: '',
              optionCode: opt.optnons,
              optionDescription: opt.optdesc,
            })),
            {
              optionIndicator: 'L',
              selection: '',
              optionCode: unit.inttrim,
              optionDescription: unit.intdesc,
            },
            {
              optionIndicator: 'P',
              selection: '',
              optionCode: unit.extcolr,
              optionDescription: unit.extdesc,
            },
          ].sort((a, b) => a.optionCode.localeCompare(b.optionCode))
        : [],
      freeAllocation: unit.zavail_alloc_ind,
      consignment: unit.zcons_ind,
      comments: unit.resv_desc,
      otp: unit.zotp,
      client: unit.client_id,
    }));
  }
  mapDealerUnitsToRowsData(units: Unit[]): PlannedVehicleRowData[] {
    return units.map((unit) => ({
      image: unit.exturl || 'image placeholder',
      VIN: unit.zvin,
      bodyNo: unit.zbody,
      modelCode: `${unit.zmodel} - ${unit.zmoddesc}`,
      status: unit.stat_code,
      template: unit.template_id,
      b: unit.zbdest,
      RFI: unit.rfi_date,
      lastTrackPoint: unit.invc_block_ind,
      transmission: unit.ztrans,
      productionWeek: unit.zprodw,
      exterior: unit.extcolr,
      interior: unit.inttrim,
      options: Array.isArray(unit.opttble)
        ? [
            ...unit.opttble.map((opt) => ({
              optionIndicator: 'S',
              selection: '',
              optionCode: opt.optnons,
              optionDescription: opt.optdesc,
            })),
            {
              optionIndicator: 'L',
              selection: '',
              optionCode: unit.inttrim,
              optionDescription: unit.intdesc,
            },
            {
              optionIndicator: 'P',
              selection: '',
              optionCode: unit.extcolr,
              optionDescription: unit.extdesc,
            },
          ].sort((a, b) => a.optionCode.localeCompare(b.optionCode))
        : [],
      freeAllocation: unit.zavail_alloc_ind,
      consignment: unit.zcons_ind,
      comments: unit.resv_desc,
      otp: unit.zotp,
      client: unit.client_id,
    }));
  }
  

  onSMSStockClick() {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'SMS Stock',
    };
    const initialSmsRequest: SmsRequest = {
      storageLocation: '',
      dspStockFlag: '',
      plantCode: '',
      nscStockFlag: '',
      quoteFlag: '',
      customerPurchaseOrderType: '',
      dashboardFlag: '',
      dealerCode: '',
      exterior: {
        optionCode: '',
        optionIndicator: '',
        optionDescription: '',
        selection: '',
      },
      interior: {
        optionCode: '',
        optionIndicator: '',
        optionDescription: '',
        selection: '',
      },
      excludeOptions: [],
      includeOptions: [],
      materialNumbers: [],
    };
    

    
    if (!this.requestPayload) {
      this.requestPayload = {} as UnitSearchStockRequest;
      this.requestPayload.impdlr = localStorage.getItem('dealerCode') || '';
    }
    this.callOption = 'SMSS';

    this.requestPayload.searchon = this.callOption;

    if (
      this.requestPayload.impmodel == '' || this.requestPayload.impmodel == undefined
    ) {
      this.toastService.pushToast({
        tone: 'critical',
        toastText: 'Please select a Model to search SMS Stock',
        id: 'error',
      });
      return;
    }
    initialSmsRequest.materialNumbers = [];
    initialSmsRequest.dealerCode = localStorage.getItem('dealerCode') || '';
    initialSmsRequest.nscStockFlag = 'X';
    initialSmsRequest.materialNumbers.push(this.requestPayload.impmodel);

    initialSmsRequest.includeOptions = [];
    initialSmsRequest.excludeOptions = [];

   if (this.requestPayload.impmodel_inopt1) {
     initialSmsRequest.includeOptions.push({
     optionCode: this.requestPayload.impmodel_inopt1,
     optionIndicator: 'S',
     optionDescription: '',
     selection: '',
     });
    }

    if (this.requestPayload.impmodel_inopt2) {
     initialSmsRequest.includeOptions.push({
     optionCode: this.requestPayload.impmodel_inopt2,
     optionIndicator: 'S',
     optionDescription: '',
     selection: '',
     });
    }

    if (this.requestPayload.impmodel_inopt3) {
     initialSmsRequest.includeOptions.push({
     optionCode: this.requestPayload.impmodel_inopt3,
     optionIndicator: 'S',
     optionDescription: '',
     selection: '',
     });
    }
    if(this.requestPayload.impmodel_exopt1){
      initialSmsRequest.excludeOptions.push({
        optionCode: this.requestPayload.impmodel_exopt1,
        optionIndicator: 'S',
        optionDescription: '',
        selection: '',
      });
    }



    if (this.requestPayload.impmodel_trim) {
      initialSmsRequest.interior.optionCode = this.requestPayload.impmodel_trim;
      initialSmsRequest.interior.optionIndicator = 'P';
    } else {
      initialSmsRequest.interior.optionCode = '';
      initialSmsRequest.interior.optionIndicator = '';
    }
    if (this.requestPayload.impmodel_colour) {
      initialSmsRequest.exterior.optionCode = this.requestPayload.impmodel_colour;
      initialSmsRequest.exterior.optionIndicator = 'L';
    } else {
      initialSmsRequest.exterior.optionCode = '';
      initialSmsRequest.exterior.optionIndicator = '';
    }
    this.stockRowsData = [];
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.smsService.getSmsStock(initialSmsRequest).subscribe(
      (response) => {
        this.showResults = true;
        this.processAvailStockResponse(response);
        this.cdr.detectChanges();
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      (error) => {
        console.error('Error fetching units:', error);
        this.showTable = false;
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      }
    );
  }
  stockItems: StockItem[] = [];
  stockRowsData: {
    image: string;
    VIN: string;
    model: string;
    description: string;
    storageLocationAvailable: string;
    visibleOnDSP: string;
    rfsDate: string;
    customer: string;
    bodyNo: string;
    rfi: string;
    ltp: string;
    exterior: string;
    interior: string;
    modelCode: string;
    otpStatus: string;
    deliveryStop: string;
    age: string;
    pw: string;
    options: StockOption[];
    optionsCount: number;
    tracking: string;
    template: string;
    dspReference: string;
    daysToExpiry: string;
    daysAtStatus: string;
    stat: string;
    download: string;
  }[] = [];
  private processAvailStockResponse(response: SmsResponse): void {
    this.stockItems = response.stock;
    if (this.stockItems && this.stockItems.length > 0) {
      this.stockRowsData = this.stockItems.map((item) => ({
        image: '', // empty initially
        VIN: item.vin,
        model: `${item.modelCode} - ${item.profileModelDescription}`,
        description: item.profileModelDescription,
        storageLocationAvailable: item.storageLocationDescription,
        visibleOnDSP: item.visibleOnDSP ? 'true' : 'false',
        rfsDate: item.rfsDate,
        customer: item.customerName,
        bodyNo: item.batchNumber,
        rfi: item.rfiWeek,
        ltp: item.lastTrackingpoint,
        exterior:
          item.options?.find((opt) => opt.optionIndicator === 'L')
            ?.optionCode || '',
        interior:
          item.options?.find((opt) => opt.optionIndicator === 'P')
            ?.optionCode || '',
        modelCode: item.modelCode,
        otpStatus: item.otpStatus,
        deliveryStop: item.deliveryStop,
        age: item.rfsDays,
        pw: item.productionWeek,
        options: item.options, // store the array, not just the length
        optionsCount: item.options.length, // for displaying the count
        tracking: item.lastTrackingpointDescription,
        template: item.templateId,
        dspReference: item.dspReference,
        daysToExpiry: item.daysToExpiry,
        daysAtStatus: item.daysAtStatus,
        stat: item.statusCode,
        download: '',
        // otpAction: this.getOtpAction(item),
      }));

      this.showTable = true;

      // Create observable array for COSY URL requests
      // const imageRequests = this.stockRowsData.map((row) => {
      //   const cosyRequest = { VIN: row['VIN'] };
      //   return this.crossBorderService.getCosyUrl(cosyRequest).pipe(
      //     catchError((err) => {
      //       console.error(`Error fetching COSY URL for VIN ${row['VIN']}`, err);
      //       return of({ exturl: 'assets/images/placeholder.png' }); // fallback placeholder
      //     })
      //   );
      // });
      //
      // forkJoin(imageRequests).subscribe((results) => {
      //   results.forEach((res, idx) => {
      //     this.stockRowsData[idx]['image'] =
      //       res.exturl || 'assets/images/placeholder.png';
      //   });
      //   this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      // });
    } else {
      this.showTable = false;
      this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
    }
  }

  onDealerStockClick() {
    this.callOption = 'DEALD';
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Dealer Stock',
    };
    if (!this.requestPayload) {
      this.requestPayload = {} as UnitSearchStockRequest;
      this.requestPayload.impdlr = localStorage.getItem('dealerCode') || '';
    }
    this.requestPayload.searchon = this.callOption;
    this.rowsData = [];
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.crossBorderService.getUnitSearchStock(this.requestPayload).subscribe(
      (response: UnitSearchResponse) => {
        this.showResults = true;
        if (response.unittab && response.unittab.length > 0) {
          this.rowsData = this.mapDealerUnitsToRowsData(response.unittab);
          this.showTable = true;
          // this.rowsData.forEach((row, idx) => {
          //   const cosyRequest = { VIN: row['VIN'] };
          //   console.log(cosyRequest);
          //   this.crossBorderService
          //     .getCosyUrl(cosyRequest)
          //     .subscribe((response: CosyUrlResponse) => {
          //       this.rowsData[idx]['image'] =
          //         response.exturl || 'image placeholder';
          //     });
          // });
        } else {
          this.showTable = false;
          this.rowsData = [];
        }
        this.cdr.detectChanges();
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      (error) => {
        console.error('Error fetching units:', error);
        this.showTable = false;
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      }
    );
  }

  protected readonly Number = Number;
  protected readonly console = console;
  protected readonly Array = Array;
  pricePerBodyRequest: PricePerBodyRequest = {
    bodyno: '',
    vin: '',
  };
  stockSheetModalIsOpen: boolean = false;
  onPricingClick(bodyNo: string) {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Loading BMW Pricing',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.pricePerBodyRequest = {
      bodyno: '',
      vin: bodyNo || '',
    };
    this.pricePerBodyService
      .getPricePerBody(this.pricePerBodyRequest)
      .subscribe(
        (response) => {
          console.log('Price per body response:', response);
          this.modelPricingModal.pricePerBodyResponse = response;
          this.modelPricingModal.processPricePerBodyResponse(response);
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          this.modelPricingModal.modelPricingModalIsOpen = true;
        },
        (error) => {
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          console.error('Error fetching price per body:', error);
          this.toastService.pushToast(error);
        }
      );
  }

  openStockSheetModal() {
    this.stockSheetModalIsOpen = true;
  }
  downloadStockSheet() {
    this.callOption = 'PLAND';
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Planned Vehicles',
    };
    if (!this.requestPayload) {
      this.requestPayload = {} as UnitSearchStockRequest;
      this.requestPayload.impdlr = localStorage.getItem('dealerCode') || '';
    }
    this.requestPayload.searchon = this.callOption;
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.crossBorderService.downloadStockSheet(this.requestPayload).subscribe({
      next: (response: Blob) => {
        this.stockSheetModalIsOpen = false;
        const fileName = `Z11UnitSearchStockXls${new Date().toISOString()}.xls`;
        const blob = new Blob([response], {
          type: 'application/vnd.ms-excel',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
        this.cdr.detectChanges();
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      },
      complete: () => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
    });
  }
}
